<template>
    <div class="listing-layout flex-column hp-10 ov-reset">
        <!-- LOADER -->
        <preloader :display="loading" class="preloader prelative" />

        <!-- HEADER -->
        <header class="flex-level mb-4">
            <!-- TITLE -->
            <h1 v-if="$slots['header'] != ''" class="m-0">
                <slot name="header"></slot>
            </h1>

            <!-- ACTIONS -->
            <div class="flex-right">
                <ul class="action-nav">
                    <li v-if="enableExport">
                        <el-dropdown placement="bottom-end">
                            <el-button
                                >{{ $l10n.__('Actions')
                                }}<i class="icon-chevron-bottom ml-2 valign-middle fs-2"></i
                            ></el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item
                                        v-for="button in secondaryButtons"
                                        :key="button.label"
                                        :class="{ disable: button.disabled }"
                                    >
                                        <a
                                            v-if="button.disabled"
                                            @click="
                                                $store.dispatch(`${listinghash}/permissionDenied`)
                                            "
                                        >
                                            {{ button.label }}
                                        </a>
                                        <a
                                            v-else-if="button.event != undefined"
                                            @click="$emit(button.event)"
                                        >
                                            {{ button.label }}
                                        </a>
                                        <a
                                            v-else
                                            :href="button.href"
                                            @click="button.click != undefined ? button.click : ''"
                                        >
                                            {{ button.label }}
                                        </a>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </li>
                    <li v-for="button in primaryButtons" :key="button.label">
                        <el-tooltip
                            :content="$t.__('common.labels.no_necessary_rights')"
                            placement="top"
                            :disabled="!button.disabled"
                        >
                            <a
                                v-if="button.type == 'vuejs'"
                                :class="{ 'btn btn-primary btn-disabled': button.disabled }"
                                @click="
                                    callBus(button.url.event, button.disabled, {
                                        linkedid: button.linkedid,
                                        linkedtype: button.linkedtype,
                                    })
                                "
                            >
                                {{ button.label }}
                            </a>
                            <a
                                v-else-if="button.event != undefined"
                                :class="{ 'btn btn-primary btn-disabled': button.disabled }"
                                @click="button.disabled ? null : $emit(button.event)"
                            >
                                {{ button.label }}
                            </a>
                            <a
                                v-else
                                :href="button.disabled ? null : button.href"
                                :class="{ 'btn btn-primary btn-disabled': button.disabled }"
                            >
                                {{ button.label }}
                            </a>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </header>
        <!-- HEADER END -->

        <!-- BODY -->
        <div class="listing prelative flex-column ov-reset mh-0 flex">
            <!-- LISTING TOOLS -->
            <div class="listing-tools flex-level flex-top no-shrink mb-2">
                <!-- FILTER -->
                <div class="flex flex-level flex-top">
                    <a
                        v-if="enableFiltering"
                        class="btn btn-small btn-primary fs-3"
                        @click.prevent="$store.dispatch(`${listinghash}/toggleDisplay`, 'filters')"
                    >
                        {{ $l10n.__('Filtrer') }}
                    </a>
                    <filters-preview v-if="!display.filters" :listinghash="listinghash" />
                </div>

                <paginator
                    :pagination="pagination"
                    :displayActions="false"
                    @pagination:update="goToPage"
                />
                <CompassToggleButtonGroup
                    v-if="switchDisplay && switchDisplay.length > 0"
                    :modelValue="activeToggleButton"
                    exclusive
                    class="ml-2"
                >
                    <CompassTooltip
                        v-for="(switchButton, switchIndex) in switchDisplay"
                        :key="switchIndex"
                        :content="switchButton.label"
                        :arrow="false"
                    >
                        <CompassToggleButton
                            :value="switchButton.id"
                            :icon="switchButton.icon"
                            @click="goToUrl(switchButton.href)"
                        />
                    </CompassTooltip>
                </CompassToggleButtonGroup>
            </div>
            <!-- LISTING TOOLS END -->

            <!-- LISTING & FILTER PANEL -->
            <div class="flex-row mh-0 flex">
                <!-- FILTER PANEL -->
                <div
                    v-show="display.filters && enableFiltering"
                    class="leftpane well well-no-shadow mr-4 flex-column"
                >
                    <filters-pane :listinghash="listinghash" />
                </div>

                <!-- COLUMN PANEL -->
                <transition name="slide-fade">
                    <listing-columns v-if="display.columns" :listinghash="listinghash" />
                </transition>

                <!-- DISPLAY OPTION PANEL -->
                <transition name="slide-fade">
                    <listing-display v-if="display.table" :listinghash="listinghash" />
                </transition>

                <!-- LISTING -->
                <div class="listingContainer br flex flex-column">
                    <!-- <div class="listingContent prelative"> -->

                    <!-- ERROR -->
                    <div v-if="error" class="placeholder">
                        <p class="acenter">
                            {{ $l10n.__('Une erreur est survenue, réinitialisez votre listing') }}
                        </p>
                        <button
                            class="btn btn-primary"
                            @click="$store.dispatch(`${listinghash}/resetListing`)"
                        >
                            {{ $l10n.__('Réinitialiser') }}
                        </button>
                    </div>

                    <!-- TABLE COMPONENT -->
                    <listing-map
                        v-if="!error"
                        :centermap="centermap"
                        :rows="rows"
                        :maptoken="maptoken"
                        :listinghash="listinghash"
                    ></listing-map>

                    <!-- </div> -->
                </div>
                <!-- LISTING END -->
            </div>
            <!-- LISTING  & FILTER PANEL END -->

            <listing-favoritesform
                v-if="display.favoritesForm"
                :listinghash="listinghash"
                :favoriteData="favoriteData"
            />

            <export-modal
                v-if="display.export"
                :listinghash="listinghash"
                :exportType="display.exportType"
            />
        </div>
        <!-- BODY END -->
    </div>
</template>

<script>
import ListingMap from './ListingMap.vue';
import FiltersPane from './FiltersPane.vue';
import FiltersPreview from './FiltersPreview.vue';
import Paginator from '../utilities/Paginator.vue';
import ListingFavoritesform from './favorites/ListingFavoriteForm.vue';
import ListingColumns from './ListingColumns.vue';
import ListingDisplay from './ListingDisplay.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import ListingModule from 'vueDir/store/maplisting';
import ExportModal from './ExportModal.vue';
import { guid } from 'vueDir/helpers';
import _ from 'lodash';

import { goToUrl } from '../../helpers';

export default {
    components: {
        Preloader,
        FiltersPane,
        Paginator,
        FiltersPreview,
        ListingColumns,
        ListingDisplay,
        ExportModal,
        ListingFavoritesform,
        ListingMap,
    },
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        maptoken: {
            type: String,
            required: true,
        },
        centermap: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        params: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        linkedtype: {
            type: String,
        },
        prefilter: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        enableFiltering: {
            type: Boolean,
            required: false,
            default: true,
        },
        enableExport: {
            type: Boolean,
            required: false,
            default: true,
        },
        favorite: {
            required: false,
            type: Number,
            default: null,
        },
        name: {
            required: false,
            type: String,
            default: '',
        },
        favoritesName: {
            required: false,
            type: String,
            default: '',
        },
        filter: {
            required: false,
            type: Object,
            default() {
                return {};
            },
        },
        buttons: {
            required: false,
            type: Array,
            default() {
                return [];
            },
        },

        useFavorites: {
            type: Boolean,
            default: true,
        },

        savedSearchesUrl: {
            type: String,
            required: false,
        },

        switchDisplay: {
            type: [Array, Boolean],
            required: false,
            default: false,
        },
    },

    data: function () {
        return {
            listinghash: '',
            activeToggleButton: 'liste-view',
        };
    },

    computed: {
        primaryButtons() {
            const primaryButtons = this.buttons.filter((button) => {
                return button.primary;
            });

            if (primaryButtons.length) {
                return primaryButtons;
            }

            return false;
        },

        secondaryButtons() {
            const secondaryButtons = this.buttons.filter((button) => {
                return button.primary == undefined || !button.primary;
            });

            if (secondaryButtons.length) {
                return secondaryButtons;
            }

            return false;
        },

        ajax() {
            return this.$store.state[this.listinghash].ajax;
        },

        kpis() {
            return this.$store.state[this.listinghash].kpis;
        },

        error() {
            return this.$store.state[this.listinghash].error;
        },

        init() {
            return this.$store.state[this.listinghash].init;
        },

        rows() {
            if (typeof this.$store.state[this.listinghash].rows === 'object') {
                return Object.values(this.$store.state[this.listinghash].rows);
            }
            return this.$store.state[this.listinghash].rows;
        },

        pagination() {
            return this.$store.state[this.listinghash].pagination;
        },
        columns() {
            return this.$store.state[this.listinghash].columns;
        },
        display() {
            return this.$store.state[this.listinghash].display;
        },

        activeColumns() {
            return this.$store.getters[`${this.listinghash}/activeColumns`];
        },

        activeFilters() {
            return this.$store.getters[`${this.listinghash}/activeFilters`];
        },

        loading() {
            return !!this.ajax;
        },

        meta() {
            return this.$store.getters[`${this.listinghash}/meta`];
        },

        permissions() {
            return this.$store.state[this.listinghash].permissions;
        },

        favoriteData() {
            return this.$store.state[this.listinghash].favoriteData;
        },

        kpis() {
            return this.$store.state[this.listinghash].kpis;
        },
    },

    created() {
        // Dynamically require state

        this.listinghash = this.name + '_' + guid();
        const store = this.$store;

        if (!(store && store.state && store.state[this.listinghash])) {
            store.registerModule(this.listinghash, ListingModule);
        }

        // Listing init
        this.$store.dispatch(`${this.listinghash}/init`, this.$props).then(() => this.fetch());
        EventBus.on('listing:refresh', this.fetch);
    },

    beforeUnmount() {
        this.$store.unregisterModule(this.listinghash);
    },

    methods: {
        goToUrl,
        setDisplayMode(display) {
            this.$store.commit(`${this.listinghash}/updateDisplayMode`, display);
        },

        // PAGINATION
        goToPage(page) {
            this.$store.commit(`${this.listinghash}/updateCurrentPage`, page);
            window.EventBus.emit('listing:updatePage', { listing: this.listinghash, page: page });
            this.fetch();
        },

        // Main methods
        fetch(overwriteMeta) {
            this.$store.dispatch(`${this.listinghash}/fetch`, overwriteMeta).then(() => {
                if (this.activeFilters.length !== 0) {
                    this.$store.commit(`${this.listinghash}/updateFiltersView`, 'summary');
                }
            });

            if (this.useFavorites) {
                this.$store.dispatch(`${this.listinghash}/fetchFavorites`);
            }
        },

        callBus(event, disable, data) {
            disable ? null : EventBus.emit(event, data);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_transitions';

.flex-row {
    .leftpane {
        width: 280px;
    }
}
</style>
